module.exports = __webpack_public_path__ + "img/broncos-logo.86abf43e.svg";